import React, { memo, useMemo } from 'react';
import { LoaderWidget, MFELoader } from '@jarvis/react-portal-addons';
import PropTypes from 'prop-types';
import StatusLoader from './styles';

import {
  getModuleDisplayedEvent,
  getModuleInitializedEvent,
  publishEvent,
} from '../../utils/analytics';

const MFE_REFS = {
  STATUS: '@jarvis/react-ecp-status-widget',
};

const StatusWidget = ({ stack, deviceCache, consolidatedPortal }) => {
  const {
    pending: isLoadingDevices,
    data: devices,
  } = consolidatedPortal ? deviceCache : { pending: false, data: [] };

  const showStatusWidget = useMemo(
    () => !isLoadingDevices, [isLoadingDevices],
  );

  if (!showStatusWidget && consolidatedPortal) {
    return (
      <StatusLoader>
        <LoaderWidget data-testid="status-widget-loader" />
      </StatusLoader>
    );
  }

  return (
    <MFELoader
      analyticsEvents={{
        moduleDisplayed: getModuleDisplayedEvent('/ReactEcpStatusWidget/', 'Status'),
      }}
      card
      component={MFE_REFS.STATUS}
      data-testid="status-widget-mfe"
      header={false}
      onLoad={() => {
        publishEvent(getModuleInitializedEvent('ReactEcpStatusWidget'));
      }}
      stack={stack}
      stateFilter={['Active', 'Pending', 'Expired']}
      settings={{
        enableLocalization: true,
        showUsers: true,
      }}
      consolidated={consolidatedPortal}
      devices={consolidatedPortal ? devices : []}
    />
  );
};

StatusWidget.defaultProps = {
  stack: 1,
  consolidatedPortal: false,
};

StatusWidget.propTypes = {
  stack: PropTypes.number,
  consolidatedPortal: PropTypes.bool,
  deviceCache: PropTypes.shape({
    pending: PropTypes.bool,
    data: PropTypes.arrayOf(PropTypes.object),
    error: PropTypes.shape({
      message: PropTypes.string,
      code: PropTypes.number,
    }),
    isFetching: PropTypes.bool,
    forceFetch: PropTypes.func,
    makeApiCall: PropTypes.func,
    success: PropTypes.bool,
  }).isRequired,
};

export default memo(StatusWidget);
